import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { isArchived, isExpired } from '~/utils/helpers';
import Register from '~/containers/Register';
import PreEventScreen from '~/components/PreEventScreen';
import PostEventScreen from '~/components/PostEventScreen';
import NewPlayer from '~/components/NewVideoPlayer';
import ExpiredEventScreen from '~/components/ExpiredEventScreen';
import NotFoundScreen from '~/components/NotFoundScreen';
import SocketClient from '~/components/SocketClient/socketClient';
import StaticClient from '~/components/StaticClient';
import { featureOn } from '~/utils/featureToggle';
import { Feature, Status } from '~/types/common';
const DONATION_WIDGET = featureOn(Feature.donation_widget);
const CustomViewer = ({ eventStatus, openFormModal, nameOnly }) => {
    const [isModalOpen, setIsModalOpen] = useState(openFormModal);
    const [watchAgain, setWatchAgain] = useState(false);
    const handleWatchAgain = useCallback(() => {
        setWatchAgain(true);
    }, []);
    const finishWatchAgain = useCallback(() => {
        setWatchAgain(false);
    }, []);
    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false);
    }, []);
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [!isArchived(eventStatus) && !isExpired(eventStatus) && _jsx(SocketClient, {}), DONATION_WIDGET && isArchived(eventStatus) ? _jsx(StaticClient, {}) : null, watchAgain ? (_jsx(NewPlayer, { onDemand: true, rewind: finishWatchAgain })) : ((() => {
                    switch (eventStatus) {
                        case Status.pending:
                        case Status.allocating:
                        case Status.allocated:
                            return _jsx(PreEventScreen, {});
                        case Status.streaming:
                        case Status.streamingFailed:
                            return _jsx(NewPlayer, { registrationRequired: isModalOpen });
                        case Status.expired:
                        case Status.retrieving:
                        case Status.retrieved:
                            return _jsx(ExpiredEventScreen, {});
                        case Status.closing:
                        case Status.closed:
                        case Status.archiving:
                        case Status.archived:
                        case Status.archivedS3:
                        case Status.archivingFailed:
                            return _jsx(PostEventScreen, { addWatchAgainButton: handleWatchAgain });
                        default:
                            return _jsx(NotFoundScreen, {});
                    }
                })()), _jsx(Register, { nameOnly: nameOnly, isOpen: isModalOpen, onRegister: handleCloseModal })] }) }));
};
const mapStateToProps = (state) => ({
    eventStatus: state.event.data.status,
});
export default connect(mapStateToProps)(CustomViewer);
